import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import classNames from 'classnames';

export const ProductImage = ({
  productId,
  profile,
  className,
}: {
  productId: number;
  profile: 'MINI' | 'THUMB' | 'MEDIUM' | 'APP' | 'LARGE' | 'ORIGINAL' | undefined;
  className?: string;
}) => {
  const { contextPath } = useContext(TenantContext);
  return (
    <img
      loading="lazy"
      src={`${contextPath}image/product_image/${productId}${profile ? `/${profile}` : ''}`}
      className={classNames(className)}
    ></img>
  );
};
